import { Button, Offcanvas } from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from "@azure/msal-browser";
import { b2cPolicies } from '../authConfig';
import React, { useState, useEffect } from 'react';
import Image from 'react-bootstrap/Image';
import ProfileImg from '../img/default_profile.jpg';
import useFetchWithMsal from '../hooks/useFetchWithMsal';
import { protectedResources, scopes } from "../authConfig";
import ProfilePhotoUpdateModal from './ProfilePhotoUpdateModal';

export const NaviMenu = () => {
    const { instance, inProgress } = useMsal();
    const [show, setShow] = useState(false);
    const [isButtonVisible, setButtonVisible] = useState(true);
    const { execute } = useFetchWithMsal({
        scopes: scopes.callapi
    });
    const [showModal, setShowModal] = useState(false);

    const handleShowModal = () => setShowModal(true);
    const handleCloseModal = () => setShowModal(false);

    const [image, setImage] = useState([]);

    const handleClose = () => {
        setShow(false);
        setButtonVisible(true);
    };

    const handleShow = () => {
        setShow(true);
        setButtonVisible(false);
    }

    let activeAccount;

    if (instance) {
        activeAccount = instance.getActiveAccount();
        console.log(activeAccount);
    }

    const handleLogoutRedirect = () => {
        instance.logoutRedirect();
    };

    const handleProfileEdit = () => {
        if (inProgress === InteractionStatus.None) {
            instance.loginRedirect(b2cPolicies.authorities.editProfile);
        }
    };

    const userId = activeAccount.localAccountId;

    // ログインユーザーのidを取得
    useEffect(() => {

        const fetchUserPhoto = async () => {
            console.log("call fetchUserPhoto");
            try {
                const response = await execute("GET", protectedResources.getUserPhoto.endpoint + "?userId=" + userId, "", true);
                console.log("check point");
                if (!response || !response.ok) {
                    console.log("HTTP Status:" + response.status);
                    throw new Error("Failed to fetch user photo");
                }
                const blob = await response.blob();
                const imageUrl = URL.createObjectURL(blob);
                setImage([imageUrl]);
            } catch (error) {
                console.log("Exception error:" + error);
                setImage([ProfileImg]);
            }
        };
        fetchUserPhoto();
    }, [execute, userId]);


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement='end' scroll="true">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title as="h2">
                        ALIVE Platform Menu
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="userProfile">
                        {activeAccount && (
                            <h2 className="userProfile__name">
                                {activeAccount.name}
                            </h2>
                        )}
                    </div>
                    <div className="drawerNav">
                        <ul className="drawerNav__list list-group list-group-flush">
                            <li className="drawerNav__item list-group-item">
                                <a href="https://alive0309.org" className='drawerNav__link' rel="noopener">
                                    ALIVE Homepage
                                </a>
                            </li>
                            <li className="drawerNav__item list-group-item">
                                <a href="https://alive0309.org/alive-platform/" className='drawerNav__link' rel="noopener">
                                    ALIVE Platform
                                </a>
                            </li>
                            <li className="drawerNav__item list-group-item">
                                <Button className='drawerNav__link p-0' variant="link" onClick={handleProfileEdit}>
                                    プロフィール編集
                                </Button>
                            </li>
                            <li className="drawerNav__item list-group-item">
                                <a href="#!" className='drawerNav__link' rel="noopener" onClick={handleShowModal}>
                                    プロフィール写真更新
                                </a>
                            </li>
                            <ProfilePhotoUpdateModal
                                show={showModal}
                                handleClose={handleCloseModal}
                                activeAccount={activeAccount}
                            />
                            <li className="drawerNav__item list-group-item">
                                <Button className='drawerNav__link p-0' variant="link" onClick={handleLogoutRedirect}>
                                    サインアウト
                                </Button>
                            </li>
                        </ul>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            {isButtonVisible && (
                <div className="position-fixed top-0 end-0 p-0" style={{ zIndex: 1050 }}>
                    <Button className="btn p-0" variant="light" onClick={handleShow} style={{ zIndex: 9999, position: 'relative', backgroundColor: 'transparent' }}>
                        <Image src={image} roundedCircle width={50} height={50} className='p-0' />
                    </Button>
                </div>
            )}
        </>
    );
};
